import Vue from 'vue'
import Router from 'vue-router'
import Auth from "./classes/Auth";

const Error = () => import('./components/Error');

const Login = () => import('./components/login/Main');
const Main = () => import('./components/Main');

const Dashboard = () => import('./components/dashboard/Main');

const BidMain = () => import('./components/bids/Main');
const BidList = () => import('./components/bids/List');

const TaskMain = () => import('./components/tasks/Main');
const TaskList = () => import('./components/tasks/List');

const VisitTomorrowMain = () => import('./components/visits/Main');
const VisitTomorrowList = () => import('./components/visits/List');

const UserMain = () => import('./components/users/Main');
const UserList = () => import('./components/users/List');
const UserAdd = () => import('./components/users/Add');
const UserEdit = () => import('./components/users/Edit');

const CompanyMain = () => import('./components/companies/Main');
const CompanyList = () => import('./components/companies/List');
const CompanyEdit = () => import('./components/companies/Edit');

const ParameterMain = () => import('./components/parameters/Main');
const ParameterEdit = () => import('./components/parameters/Edit');

const DirectionMain = () => import('./components/directions/Main');
const DirectionList = () => import('./components/directions/List');
const DirectionEdit = () => import('./components/directions/Edit');
const SalarySchemeList = () => import('./components/directions/SalarySchemeList');
const SalarySchemeEdit = () => import('./components/directions/SalarySchemeEdit');

const FiliationMain = () => import('./components/filiations/Main');
const FiliationList = () => import('./components/filiations/List');
const FiliationEdit = () => import('./components/filiations/Edit');

const FitnessRoomMain = () => import('./components/fitness_rooms/Main');
const FitnessRoomList = () => import('./components/fitness_rooms/List');
const FitnessRoomEdit = () => import('./components/fitness_rooms/Edit');

const SubscriptionMain = () => import('./components/subscriptions/Main');
const SubscriptionList = () => import('./components/subscriptions/List');
const SubscriptionEdit = () => import('./components/subscriptions/Edit');

const CatalogMain = () => import('./components/catalog/Main');
const CatalogList = () => import('./components/catalog/List');
const CatalogGoodEdit = () => import('./components/catalog/GoodEdit');

const TrainerMain = () => import('./components/trainer/Main');
const TrainerList = () => import('./components/trainer/List');
const TrainerEdit = () => import('./components/trainer/Edit');

const CashflowMain = () => import('./components/cashflow/Main');
const CashflowList = () => import('./components/cashflow/List');
const CashflowLess = () => import('./components/cashflow/Less');

const ScheduleMain = () => import('./components/schedule/Main');
const ScheduleList = () => import('./components/schedule/List');
const ScheduleGroupMain = () => import('./components/schedule/group/Main');
const ScheduleGroupList = () => import('./components/schedule/group/List');
const ScheduleGroupAdd = () => import('./components/schedule/group/Add');
const ScheduleGroupEdit = () => import('./components/schedule/group/Edit');


const ClientMain = () => import('./components/clients/Main');
const ClientList = () => import('./components/clients/List');
const ClientAdd = () => import('./components/clients/Add');
const ClientEdit = () => import('./components/clients/Edit');
const ClientSubscriptionList = () => import('./components/clients/subscription/List');

const CallMain = () => import('./components/calls/Main');
const CallList = () => import('./components/calls/List');

const SmsMain = () => import('./components/sms/Main');
const SmsList = () => import('./components/sms/List');

const ReportMain = () => import('./components/reports/Main');
const ReportNoVisitClients = () => import('./components/reports/NoVisitClients');

Vue.use(Router);

let vueRouter = new Router({
    mode: 'history',

    routes: [
        {
            path: '/',
            redirect: {name: 'dashboard'},
            component: Main,
            meta: {
                requiresAuth: true,
            },
            children: [

                {
                    path: 'dashboard',
                    name: 'dashboard',
                    component: Dashboard,
                    meta: {
                        requiresAuth: true,
                    }
                },

                {
                    path: 'schedule',
                    name: 'schedule',
                    component: ScheduleMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list/:id',
                            name: 'schedule-list',
                            component: ScheduleList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'group',
                            name: 'schedule-groups',
                            component: ScheduleGroupMain,
                            meta: {
                                requiresAuth: true,
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'schedule-group-list',
                                    component: ScheduleGroupList,
                                    meta: {
                                        requiresAuth: true,
                                    }
                                },
                                {
                                    path: 'add',
                                    name: 'schedule-group-add',
                                    component: ScheduleGroupAdd,
                                    meta: {
                                        requiresAuth: true,
                                    }
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'schedule-group-edit',
                                    component: ScheduleGroupEdit,
                                    meta: {
                                        requiresAuth: true,
                                    }
                                },
                            ],
                        },
                    ],
                },
                {
                    path: 'users',
                    name: 'users',
                    component: UserMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'users-list',
                            component: UserList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'users-add',
                            component: UserAdd,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'users-edit',
                            component: UserEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'cashflow',
                    name: 'cashflow',
                    component: CashflowMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'cashflow-list',
                            component: CashflowList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        // {
                        //     path: 'add',
                        //     name: 'cashflow-gain',
                        //     component: CashflowGain,
                        //     meta: {
                        //         requiresAuth: true,
                        //     }
                        // },
                        {
                            path: 'less',
                            name: 'cashflow-less',
                            component: CashflowLess,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'clients',
                    name: 'clients',
                    component: ClientMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'clients-list',
                            component: ClientList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'clients-add',
                            component: ClientAdd,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'clients-edit',
                            component: ClientEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'subscription-list',
                            name: 'clients-subscription-list',
                            component: ClientSubscriptionList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'reports',
                    name: 'reports',
                    component: ReportMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'no-visit-clients',
                            name: 'report-no-visit-clients',
                            component: ReportNoVisitClients,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'with-visit-clients',
                            name: 'report-with-visit-clients',
                            component: () => import('./components/reports/WithVisitClients'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'trainer-salary',
                            name: 'report-trainer-salary',
                            component: () => import('./components/reports/ReportTrainerSalary'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'trainer-efficiency',
                            name: 'report-trainer-efficiency',
                            component: () => import('./components/reports/ReportTrainerEfficiency'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'group-efficiency',
                            name: 'report-group-efficiency',
                            component: () => import('./components/reports/ReportGroupEfficiency'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'admin-efficiency',
                            name: 'report-admin-efficiency',
                            component: () => import('./components/reports/ReportAdminEfficiency'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'client-source',
                            name: 'report-client-source',
                            component: () => import('./components/reports/ClientSource'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'cashflow-info',
                            name: 'report-cashflow-info',
                            component: () => import('./components/reports/CashflowInfo'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'average-duration-between-sale',
                            name: 'report-average-duration-between-sale',
                            component: () => import('./components/reports/AverageDurationBetweenSale'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'average-duration-between-visit',
                            name: 'report-average-duration-between-visit',
                            component: () => import('./components/reports/AverageDurationBetweenVisit'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'sale-week-info',
                            name: 'report-sale-week-info',
                            component: () => import('./components/reports/SaleWeekInfo'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'client-by-source',
                            name: 'report-client-by-source',
                            component: () => import('./components/reports/ClientBySource'),
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'directions',
                    name: 'directions',
                    component: DirectionMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'directions-list',
                            component: DirectionList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'directions-add',
                            component: DirectionEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'directions-edit',
                            component: DirectionEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'salary-scheme-list',
                            name: 'salary-scheme-list',
                            component: SalarySchemeList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'salary-scheme-edit/:id',
                            name: 'salary-scheme-edit',
                            component: SalarySchemeEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'subscriptions',
                    name: 'subscriptions',
                    component: SubscriptionMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'subscriptions-list',
                            component: SubscriptionList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'subscriptions-add',
                            component: SubscriptionEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'subscriptions-edit',
                            component: SubscriptionEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'catalog',
                    name: 'catalog',
                    component: CatalogMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'catalog-list',
                            component: CatalogList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'good/add',
                            name: 'catalog-good-add',
                            component: CatalogGoodEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'good/edit/:id',
                            name: 'catalog-good-edit',
                            component: CatalogGoodEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'filiations',
                    name: 'filiations',
                    component: FiliationMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'filiations-list',
                            component: FiliationList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'filiations-add',
                            component: FiliationEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'filiations-edit',
                            component: FiliationEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'fitness-rooms',
                    name: 'fitness-rooms',
                    component: FitnessRoomMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'fitness-rooms-list',
                            component: FitnessRoomList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'fitness-rooms-add',
                            component: FitnessRoomEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'fitness-rooms-edit',
                            component: FitnessRoomEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'trainers',
                    name: 'trainers',
                    component: TrainerMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'trainers-list',
                            component: TrainerList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'trainers-add',
                            component: TrainerEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'trainers-edit',
                            component: TrainerEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'bids',
                    name: 'bids',
                    component: BidMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'bids-list',
                            component: BidList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'tasks',
                    name: 'tasks',
                    component: TaskMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'tasks-list',
                            component: TaskList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'visits-tomorrow',
                    name: 'visits-tomorrow',
                    component: VisitTomorrowMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'visits-tomorrow-list',
                            component: VisitTomorrowList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'calls',
                    name: 'calls',
                    component: CallMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'calls-list',
                            component: CallList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'sms',
                    name: 'sms',
                    component: SmsMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'sms-list',
                            component: SmsList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'companies',
                    name: 'companies',
                    component: CompanyMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'companies-list',
                            component: CompanyList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'companies-add',
                            component: CompanyEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'companies-edit',
                            component: CompanyEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },
                {
                    path: 'parameters',
                    name: 'parameters',
                    component: ParameterMain,
                    meta: {
                        requiresAuth: true,
                    },
                    children: [
                        {
                            path: 'edit',
                            name: 'parameters-edit',
                            component: ParameterEdit,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ],
                },

            ],
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                requiresAuth: false,
            },
            beforeEnter: (to, from, next) => {
                if (Auth.check() === true) {
                    next({
                        name: 'dashboard',
                    });
                } else {
                    next();
                }
            }
        },
        {
            path: '*',
            name: 'error',
            component: Error,
            params: {
                code: 404,
                trace: '',
                message: '',
            },
            meta: {
                requiresAuth: false,
            }
        },
    ]
});

vueRouter.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (Auth.check() === true) {
            next();
        } else {
            next({
                name: 'login',
                query: {redirect: to.fullPath}
            });
        }
    } else {
        next();
    }
});

export default vueRouter;
